import React, { useEffect, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import usePageTitle from '../../hooks/usePageTitle';
import { UsersList } from '../../components/UsersList';
import { UsersGraph } from '../../components/UsersGraph';
import { CONTAINER_CONTENT_CLASS } from '../signatures/SignaturesRoutes';
import useLocalizedCopy from '../../hooks/useLocalizedCopy';
import { usePageHeader } from '../../contexts/PageHeaderContext';

interface UsersWithDashboardProps {
    viewType?: 'list' | 'dashboard';
}

export function UsersWithDashboard({ viewType = 'list' }: UsersWithDashboardProps) {
    const location = useLocation();
    const { copy } = useLocalizedCopy();
    const { setPageHeader } = usePageHeader();
    
    usePageTitle(copy.Management.viewUsers);
    
    const isListView = viewType === 'list';
    const isDashboardView = viewType === 'dashboard';

    // Create navigation items with useMemo to prevent recreating on every render
    const navigationItems = useMemo(() => (
        <div className="flex gap-4 text-sm">
            <Link 
                to="/management/users/list" 
                className={isListView ? "text-primary font-semibold" : "text-gray-600 hover:text-primary"}
            >
                List View
            </Link>
            <Link 
                to="/management/users/dashboard"
                className={isDashboardView ? "text-primary font-semibold" : "text-gray-600 hover:text-primary"}
            >
                Dashboard
            </Link>
        </div>
    ), [isListView, isDashboardView]);

    useEffect(() => {
        setPageHeader(copy.Management.viewUsers, navigationItems);
        
        return () => setPageHeader(null);
    }, [copy.Management.viewUsers, navigationItems, setPageHeader]);

    return (
        <div className="container-fixed">
            {isListView ? <UsersList /> : <UsersGraph />}
        </div>
    );
}